// Hooks
import useSearchParams from '../../../../hooks/useSearchParams';

/** @import  * as Types from  '../../../../services/types' */
/** @import { BU_ZOL, BU_QWERI, BU_BANZAI } from "../../../../constants" */
/**
   * Returns the active business unit and the handler for changing the business unit.
   * @returns {{
  *   activeBusinessUnit: BU_ZOL | BU_QWERI | BU_BANZAI | null,
  *   handleBusinessUnitChange: (businessUnit: BU_ZOL | BU_QWERI | BU_BANZAI) => void
  *   filterPostsByBusinessUnit: (posts: {data: Array<Types.Post>},
  *   resources: {data:Array<Types.Resource>}) => {data: Array<Types.Post>}
  * }}
  */
const useListBusinessUnit = () => {
  const { getSearchParams, updateSearchParams } = useSearchParams();
  const {
    businessUnit = null,
  } = getSearchParams();

  /**
   * Handles the change of the business unit.
   * @param {BU_ZOL | BU_QWERI | BU_BANZAI} unit
  */
  const handleBusinessUnitChange = (unit) => {
    if (businessUnit !== unit) {
      updateSearchParams({ businessUnit: unit }, true);
    } else {
      updateSearchParams({ businessUnit: null }, true);
    }
  };

  /**
   * Returns the posts filtered by the active business unit.
   * @param {{data: Array<Types.Post>}} posts
   * @param {{data: Array<Types.Resource>}} resources
   */
  const filterPostsByBusinessUnit = (posts, resources) => {
    const resourcesBusinessUnit = resources.data.reduce((acc, resource) => {
      const updatedAcc = { ...acc };
      if (!updatedAcc[resource.businessUnit]) {
        updatedAcc[resource.businessUnit] = {};
      }
      updatedAcc[resource.businessUnit][resource.id] = resource;
      return updatedAcc;
    }, {});

    return {
      ...posts,
      data: posts.data.reduce((acc, post) => {
        if (resourcesBusinessUnit?.[businessUnit]?.[post.resourceId]) {
          return [...acc, post];
        }
        return acc;
      }, []),
    };
  };

  return {
    activeBusinessUnit: businessUnit,
    handleBusinessUnitChange,
    filterPostsByBusinessUnit,
  };
};

export default useListBusinessUnit;
